import { EyeIcon, EyeSlashIcon, UserPlusIcon } from '@heroicons/react/24/outline';
import { Button, Input, Switch } from '@nextui-org/react';
import React from 'react';

import { ModernModal } from '@portal/components/common/ModernModal.ui';

interface AddUserModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  formData: {
    username: string;
    password: string;
    is_active: boolean;
    is_admin: boolean;
  };
  onFormDataChange: (data: { username: string; password: string; is_active: boolean; is_admin: boolean }) => void;
  showPassword: boolean;
  onShowPasswordChange: (show: boolean) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

export const AddUserModal: React.FC<AddUserModalProps> = ({
  isOpen,
  onOpenChange,
  formData,
  onFormDataChange,
  showPassword,
  onShowPasswordChange,
  onSubmit,
  isLoading,
}) => {
  const icon = <UserPlusIcon className='h-4 w-4' />;

  const footer = (
    <>
      <Button color='danger' variant='light' onPress={onOpenChange} disabled={isLoading}>
        Cancel
      </Button>
      <Button color='primary' onPress={onSubmit} isLoading={isLoading}>
        Add User
      </Button>
    </>
  );

  return (
    <ModernModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title='Add New User'
      subtitle='Create a new user account'
      icon={icon}
      size='md'
      footer={footer}
    >
      <div className='flex flex-col gap-4'>
        <Input
          label='Username'
          placeholder='Enter username'
          value={formData.username}
          onValueChange={value => onFormDataChange({ ...formData, username: value })}
          isRequired
        />
        <Input
          label='Password'
          placeholder='Enter password'
          type={showPassword ? 'text' : 'password'}
          value={formData.password}
          onValueChange={value => onFormDataChange({ ...formData, password: value })}
          endContent={
            <button className='focus:outline-none' type='button' onClick={() => onShowPasswordChange(!showPassword)}>
              {showPassword ? (
                <EyeSlashIcon className='h-4 w-4 text-gray-400' />
              ) : (
                <EyeIcon className='h-4 w-4 text-gray-400' />
              )}
            </button>
          }
          isRequired
        />
        <div className='flex gap-4'>
          <Switch
            isSelected={formData.is_active}
            onValueChange={value => onFormDataChange({ ...formData, is_active: value })}
          >
            Active
          </Switch>
          <Switch
            isSelected={formData.is_admin}
            onValueChange={value => onFormDataChange({ ...formData, is_admin: value })}
          >
            Admin
          </Switch>
        </div>
      </div>
    </ModernModal>
  );
};
